export const JOURNEY_ID_HEADER = 'x-r-journey-id';
export const STORAGE_KEY = 'mmt_rails_journey_id';

let journeyId: string | null = null;

function generateUUID(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function readFromStorage(): string | null {
  try {
    if (typeof sessionStorage === 'undefined') return null;
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function writeToStorage(id: string): void {
  try {
    if (typeof sessionStorage === 'undefined') return;
    sessionStorage.setItem(STORAGE_KEY, id);
  } catch {
    // ignore
  }
}

function clearStorage(): void {
  try {
    if (typeof sessionStorage === 'undefined') return;
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

export const createJourneyId = (): string => {
  journeyId = generateUUID();
  writeToStorage(journeyId);
  return journeyId;
};

export const getJourneyIdHeader = (): string => {
  if (journeyId) return journeyId;
  const stored = readFromStorage();
  if (stored) {
    journeyId = stored;
    return journeyId;
  }
  return createJourneyId();
};

export const invalidateJourneyId = (): void => {
  journeyId = null;
  clearStorage();
};

export const hasJourneyId = (): boolean => {
  return journeyId !== null || readFromStorage() !== null;
};
